































































import { Vue, Prop, Component } from "vue-property-decorator";

import { IActivityScore } from "@/models/interfaces/report-generator";

@Component
export default class ReportTableScore extends Vue {
  /**
   * The activities data for displaying/calculating a score
   */
  @Prop({ required: true })
  private activities!: IActivityScore[];

  private computedClass(item: IActivityScore) {
    const scorePercentage = (item.userScore / Number(item.totalScore)) * 100;

    if (!scorePercentage) {
      return "score__item--empty";
    }

    if (scorePercentage >= 0 && scorePercentage <= 49) {
      return "score__item--medium";
    } else if (scorePercentage >= 50 && scorePercentage <= 99) {
      return "score__item--good";
    } else {
      return "score__item--perfect";
    }
  }
}
